import React, {useEffect, useState} from 'react';
import {HelpCenterChatbot} from './HelpCenterChatbot';
import {useHelpCenterChatbot} from './hooks/useHelpCenterChatbot';

enum HelpCenterChatbotState {
  Open = 'open',
  Show = 'show',
}

export const HelpCenterChatbotOpener: React.FC = () => {
  const {open, isOpen, isShown, show} = useHelpCenterChatbot();
  const [mountChatbot, setMountChatbot] = useState(false);

  // Stores in route state info that the chatbot was open when the user reloads the page.
  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    const updateRouteState = () => {
      let helpCenterChatbotState;

      if (isShown) {
        helpCenterChatbotState = HelpCenterChatbotState.Show;
      }

      if (isOpen) {
        helpCenterChatbotState = HelpCenterChatbotState.Open;
      }

      window.history.replaceState(
        {...window.history.state, helpCenterChatbotState},
        '',
      );
    };

    if (isShown) {
      window.addEventListener('beforeunload', updateRouteState);
    }

    return () => {
      if (isShown) {
        window.removeEventListener('beforeunload', updateRouteState);
      }
    };
  }, [isOpen, isShown]);

  // Opens the chatbot when the user reloads the page if it was open before.
  useEffect(() => {
    const helpCenterChatbotState = window.history.state?.helpCenterChatbotState;

    // setTimout is used here to make sure that react-query has updated the cache
    // when open is called. Calling it immediately doesn't update the cache.
    if (helpCenterChatbotState) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setTimeout(
        helpCenterChatbotState === HelpCenterChatbotState.Open ? open : show,
      );
    }
  }, []);

  // Make sure that the chatbot is mounted on first open and never unmounts since the launcher stays rendered.
  useEffect(() => {
    if (isShown && !mountChatbot) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setMountChatbot(true);
    }
  }, [isShown, mountChatbot]);

  if (mountChatbot) {
    return <HelpCenterChatbot />;
  }

  return null;
};
